import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
const renderHeaderCell = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/_jsx("th", {
    "aria-hidden": !title ? true : undefined
  }, title, title);
};
const renderDataCell = (_ref2, index) => {
  let {
    value,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement("td", Object.assign({
    key: index
  }, rest), value);
};

/**
*   DataTable will accept a data prop that is an array of data objects and render a table with a data row for each item.
*   Columns are defined by passing <DataTable.Column> child components to the <DataTable>.
*   The <DataTable> components should have a title prop, a dataKey, and an optional render method.
*/
function DataTable(_ref3) {
  let {
    data,
    className,
    children,
    striped = false,
    bordered = false,
    hover = false,
    condensed = false,
    unstyled = false,
    ...rest
  } = _ref3;
  const columns = React.Children.map(children, child => child.props);
  const rootClassName = clsx({
    table: true,
    'table-striped': striped,
    'table-bordered': bordered,
    'table-hover': hover,
    'table-condensed': condensed,
    'table-unstyled': unstyled
  }, className);
  const renderDataCells = (row, rowIndex) => columns.map((_ref4, columnIndex) => {
    let {
      render,
      dataKey,
      ...columnRest
    } = _ref4;
    let value = row[dataKey];
    if (typeof render === 'function') {
      value = render({
        value: row[dataKey],
        columns,
        row,
        rowIndex,
        columnIndex
      });
    }
    return renderDataCell({
      value,
      ...columnRest
    }, columnIndex);
  });
  const renderDataRows = () => data.map((row, rowIndex) => /*#__PURE__*/_jsx("tr", {}, rowIndex, renderDataCells(row, rowIndex)));
  const renderThead = () => columns.find(column => !!column.title) && /*#__PURE__*/_jsx("thead", {}, void 0, /*#__PURE__*/_jsx("tr", {}, void 0, columns.map(renderHeaderCell)));
  return /*#__PURE__*/React.createElement("table", Object.assign({
    "data-cmp": "dataTable"
  }, rest, {
    className: rootClassName
  }), renderThead(), /*#__PURE__*/_jsx("tbody", {}, void 0, renderDataRows()));
}
DataTable.Column = props => {
  // eslint-disable-next-line no-unused-vars
  const {
    dataKey,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("div", rest);
};
export default DataTable;